import Vue from 'vue';

import FormBuilder from '@cnamts/form-builder';

Vue.use(FormBuilder);
